import React, { useRef } from "react";
import emailjs from "emailjs-com";

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_nmk5qa6",
        "template_7lorfkc",
        form.current,
        "v0msx-V4tmMb9LluI"
      )
      .then(() => {
        alert("Message sent!");
      })
      .catch((err) => console.log(err));
  };

  return (
    <section id="contact" className="py-5 bg-dark text-white">
      <div className="container" style={{ maxWidth: "600px" }}>
        <h2 className="text-center mb-4">Contact Me</h2>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            className="form-control mb-3"
            placeholder="Your Name"
            required
          />

          <input
            type="email"
            name="email"
            className="form-control mb-3"
            placeholder="Your Email"
            required
          />

          <textarea
            name="message"
            rows="4"
            className="form-control mb-3"
            placeholder="Your Message"
            required
          />

          <button type="submit" className="btn btn-info w-100">
            Send Message
          </button>
        </form>

        <div className="text-center mt-4">
          <p className="fw-bold">You can also reach me at:</p>
          <p className="mb-1">📧 nataliedambaza@gmail.com</p>

          <div>
            <a href="https://github.com/Ndambaza" className="me-3 text-info">
              <i className="fa-brands fa-github"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/natalie-dambaza/"
              className="text-info"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
